import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, FileText, Phone } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MODULO_URL } from "@/components/AttivazioneForm";

const TEL = "3476172250";
const eur = (v) => Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const PkgCard = ({ p, onPick }) => {
  const onRequest = !p.price_eur;
  return (
    <div data-testid={`public-package-${p.id}`} className="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg">
      <div className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">{p.name}</div>
      {onRequest ? (
        <div className="mt-4 font-display text-3xl font-extrabold text-slate-900">Su richiesta</div>
      ) : (
        <div className="mt-4 flex items-baseline gap-1">
          <span className="font-display text-4xl font-extrabold text-slate-900" data-testid={`public-package-price-${p.id}`}>{eur(p.price_eur)} €</span>
          <span className="text-sm text-slate-500">all'anno</span>
        </div>
      )}
      <div className="mt-3 flex items-center gap-2 text-sm text-slate-700">
        <FileText className="h-4 w-4 text-sky-600" />{onRequest ? "Quantità di documenti XML su misura" : `${p.xml_quota} documenti XML all'anno`}
      </div>
      {onRequest ? (
        <a href={`tel:${TEL}`} data-testid={`public-package-phone-${p.id}`} className="mt-2 inline-flex items-center gap-2 text-sm font-semibold text-sky-700 hover:underline"><Phone className="h-4 w-4" />Chiama il {TEL}</a>
      ) : p.description && !p.description.includes("documenti XML") && <p className="mt-2 text-sm text-slate-500">{p.description}</p>}
      <div className="flex-1" />
      <Button data-testid={`public-package-request-${p.id}`} onClick={() => onPick(p)} className="mt-6 h-11 w-full bg-blue-600 hover:bg-blue-700">
        Richiedi apertura
      </Button>
    </div>
  );
};

export const PackagesSection = () => {
  const [pkgs, setPkgs] = useState([]);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/public/packages").then((r) => setPkgs(r.data)).catch(() => setPkgs([]));
  }, []);
  useEffect(() => {
    if (pkgs.length && window.location.hash === "#prezzi") document.getElementById("prezzi")?.scrollIntoView();
  }, [pkgs]);
  if (!pkgs.length) return null;
  return (
    <section id="prezzi" data-testid="packages-section" className="border-b border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-sky-700">Pacchetti e prezzi</div>
        <h2 className="mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Scegli il pacchetto in base ai documenti che emetti e ricevi</h2>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {[...pkgs.filter((p) => p.price_eur), ...pkgs.filter((p) => !p.price_eur)].map((p) => <PkgCard key={p.id} p={p} onPick={(x) => nav(`/attivazione/${x.id}`)} />)}
        </div>
        <a href={MODULO_URL} data-testid="packages-blank-pdf-link" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-sky-700 hover:underline">
          <Download className="h-4 w-4" />Scarica il modulo di richiesta attivazione in PDF da compilare e firmare
        </a>
      </div>
    </section>
  );
};
